import { useContext } from "react";
import AppContext from "../context";
import { FaMinus, FaPlus, FaTrash } from "react-icons/fa";
import { trimProductTitle } from "../util/helpers";

const ShoppingCart = ({ handleCloseModal }) => {
  const {
    cart,
    handleSetOrderState,
    increaseInsertQuantity,
    decreaseInsertQuantity,
    removeInsertFromCart,
    cartTotalPrice,
    handleSetGlobalModal,
    triggerDimensionsUpdate,
    handleSetSelectedMaterial,
    handleSetSelectedBottomType,
    handleSetSelectedBottomColor,
    handleSetBottomRequired,
    setEditedItem,
    handleSetCurrentInsertDimensions,
  } = useContext(AppContext);

  const editInsert = (item) => {
    handleCloseModal();
    handleSetGlobalModal(
      <div className="common-modal">
        <div className="common-modal__content content">
          <h2>
            Edit <strong>{item.title}</strong>
          </h2>
          <p>
            Are you sure you want to edit this insert? Changes to your current
            insert will be lost.
          </p>
          <div className="buttons">
            <button
              className="button is-success"
              onClick={() => {
                setEditedItem(item);
                handleSetGlobalModal(null, { forceClose: true });
                window?.loadInsert?.(item.insertJson);
                handleSetSelectedMaterial(item.material);
                handleSetCurrentInsertDimensions(item.dimensions);
                handleSetBottomRequired(item.bottomRequired);
                const bottomRequiredInput =
                  document.getElementById("bottom-required");
                if (bottomRequiredInput)
                  bottomRequiredInput.checked = item.bottomRequired;
                if (item.bottomRequired) {
                  const bottomType = trimProductTitle(
                    item.bottom.bottomMaterial.node.title
                  ).toLowerCase();
                  handleSetSelectedBottomColor(item.bottom.color, bottomType);
                  handleSetSelectedBottomType(bottomType, item.bottom.color);
                }
                window?.checkBottomRequired();
                // Give some time for the material to load before triggering dimensions update
                setTimeout(() => {
                  triggerDimensionsUpdate();
                }, 500);
              }}
            >
              Yes
            </button>
            <button
              className="button is-danger"
              onClick={() => {
                handleSetGlobalModal(null, { forceClose: true });
              }}
            >
              No
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="shopping-cart">
      <p className="title is-size-3 has-text-dark tac mb-3">Shopping cart</p>
      {cart && cart.length > 0 ? (
        <>
          <div className="shopping-cart__items">
            {cart.map((item) =>
              item.isAdditionalProduct ? (
                <div className="shopping-cart__items--item" key={item.id}>
                  <div>
                    <p className="title is-size-5 has-text-dark mb-1">
                      {item.title}
                    </p>
                    <p>
                      {item.quantity > 1
                        ? `$${((item.price * item.quantity) / 100).toFixed(
                            2
                          )} (${item.quantity}x ${(item.price / 100).toFixed(
                            2
                          )})`
                        : `$${(item.price / 100).toFixed(2)}`}
                    </p>
                  </div>
                  <div className="is-flex is-flex-direction-column is-justify-content-space-between is-align-items-flex-end">
                    <button
                      className="shopping-cart__items--item__remove-button reset-button is-clickable"
                      onClick={() => removeInsertFromCart(item)}
                    >
                      <i>
                        <FaTrash />
                      </i>
                    </button>
                    <div className="shopping-cart__items--item__quantity">
                      <button
                        className="reset-button is-clickable"
                        disabled={item.baseProduct.node.productType === "SVG"}
                        onClick={() => {
                          if (item.quantity > 0) {
                            decreaseInsertQuantity(item);
                          }
                        }}
                      >
                        <i>
                          <FaMinus />
                        </i>
                      </button>
                      <p>{item.quantity}</p>
                      <button
                        className="reset-button is-clickable"
                        disabled={item.baseProduct.node.productType === "SVG"}
                        onClick={() => {
                          increaseInsertQuantity(item);
                        }}
                      >
                        <i>
                          <FaPlus />
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="shopping-cart__items--item" key={item.id}>
                  <div>
                    <p className="title is-size-5 has-text-dark mb-1">
                      {item.title}
                    </p>
                    <div className="is-flex">
                      <p>
                        {item.dimensions.width.in.integer}
                        {item.dimensions.width.in.fraction.numerator === 0 ? (
                          ""
                        ) : (
                          <span className="is-size-7">
                            {" "}
                            <sup>
                              {item.dimensions.width.in.fraction.numerator}
                            </sup>
                            /
                            <sub>
                              {item.dimensions.width.in.fraction.denominator}
                            </sub>
                          </span>
                        )}
                        ″ x {item.dimensions.depth.in.integer}
                        {item.dimensions.depth.in.fraction.numerator === 0 ? (
                          ""
                        ) : (
                          <span className="is-size-7">
                            <sup>
                              {item.dimensions.depth.in.fraction.numerator}
                            </sup>
                            /
                            <sub>
                              {item.dimensions.depth.in.fraction.denominator}
                            </sub>
                          </span>
                        )}
                        ″ x {item.dimensions.height.in.integer}{" "}
                        {item.dimensions.height.in.fraction.numerator === 0 ? (
                          ""
                        ) : (
                          <span className="is-size-7">
                            <sup>
                              {item.dimensions.height.in.fraction.numerator}
                            </sup>
                            /
                            <sub>
                              {item.dimensions.height.in.fraction.denominator}
                            </sub>
                          </span>
                        )}
                        ″
                      </p>
                    </div>
                    <p>{`(${item.dimensions.width.cm}cm x ${item.dimensions.depth.cm}cm x ${item.dimensions.height.cm}cm)`}</p>
                    <p>
                      {" "}
                      {item.quantity > 1
                        ? `$${((item.price * item.quantity) / 100).toFixed(
                            2
                          )} (${item.quantity} x $${(item.price / 100).toFixed(
                            2
                          )})`
                        : `$${(item.price / 100).toFixed(2)}`}
                    </p>
                  </div>
                  <div className="is-flex is-flex-direction-column is-justify-content-space-between is-align-items-flex-end">
                    <button
                      className="shopping-cart__items--item__remove-button reset-button is-clickable"
                      onClick={() => removeInsertFromCart(item)}
                    >
                      <i>
                        <FaTrash />
                      </i>
                    </button>
                    <button
                      className="is-clickable shopping-cart__items--item__edit-button"
                      disabled={!item.insertJson}
                      onClick={() => editInsert(item)}
                    >
                      Edit
                    </button>
                    <div className="shopping-cart__items--item__quantity">
                      <button
                        className="reset-button is-clickable"
                        disabled={item.baseProduct.node.productType === "SVG"}
                        onClick={() => {
                          if (item.quantity > 0) {
                            decreaseInsertQuantity(item);
                          }
                        }}
                      >
                        <i>
                          <FaMinus />
                        </i>
                      </button>
                      <p>{item.quantity}</p>
                      <button
                        className="reset-button is-clickable"
                        disabled={item.baseProduct.node.productType === "SVG"}
                        onClick={() => {
                          increaseInsertQuantity(item);
                        }}
                      >
                        <i>
                          <FaPlus />
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
          <div className="shopping-cart__proceed">
            <p className="has-text-weight-bold is-size-5">
              Total: ${cartTotalPrice.toFixed(2)}
            </p>
            <button
              className="button is-success"
              onClick={() => {
                handleCloseModal();
                handleSetOrderState("summary");
              }}
            >
              Order summary
            </button>
          </div>
        </>
      ) : (
        <p className="tac">Your shopping cart is empty.</p>
      )}
    </div>
  );
};

export default ShoppingCart;
